import { motion } from "framer-motion";

export default function PageHero({ kicker, title, subtitle, image }) {
  return (
    <section data-testid="page-hero" className="relative overflow-hidden bg-obsidian pt-36 pb-20 text-cream md:pt-44 md:pb-28">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/80 to-obsidian/60" />
        </div>
      )}
      <div className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{ backgroundImage: "linear-gradient(#fff 1px,transparent 1px),linear-gradient(90deg,#fff 1px,transparent 1px)", backgroundSize: "64px 64px" }} />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-12">
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          className="text-xs uppercase tracking-[0.25em] text-gold">{kicker}</motion.p>
        <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
          className="mt-5 max-w-4xl font-heading text-5xl font-extrabold leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">{title}</motion.h1>
        {subtitle && (
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}
            className="mt-6 max-w-2xl text-lg leading-relaxed text-cream/70">{subtitle}</motion.p>
        )}
      </div>
    </section>
  );
}
